import React from "react"
import parse from "html-react-parser"
import { useMediaQuery, useTheme } from "@mui/material"

import * as S from "./solutions-hero.styles"

const SolutionsHero = ({ backgroundImage, leftImage, rightImage, title }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  return (
    <S.Section>
      <S.BgImage img={backgroundImage} tag="div">
        <S.Wrapper maxWidth="xl">
          <S.Title>{parse(title)}</S.Title>
        </S.Wrapper>
        {!isMobile && <S.LeftImage img={leftImage} />}
        <S.RightImage img={rightImage} />
      </S.BgImage>
    </S.Section>
  )
}

export default SolutionsHero
